<template>
  <v-container fluid class="pt-0 mt-2">
    <v-row v-if="mode === 'alert'" class="pl-3">
      <span class="text-h6 font-weight-bold primary--text">{{ alertTitle }}</span>
   </v-row>
   <v-card elevation="0" outlined class="w-100 my-5">
    <!--Show only-->
    <v-row class="ma-0 justify-center align-center" v-if="mode === 'favorite'">
      <v-col cols="12" md="2" class="pa-0">
        <v-card-title class="body-1 font-weight-bold primary--text">{{ $t("favorites.showOnly") }}</v-card-title>
      </v-col>
      <v-col cols="12" md="10" class="d-flex align-center justify-start">
        <v-card-text class="pa-0">
            <v-radio-group background-color="transparent" row hide-details class="ma-0 pa-0"
              :column="$vuetify.breakpoint.smAndDown" :row="!$vuetify.breakpoint.smAndDown"
              v-model="showOnly"
              @change="onShowOnlyChange($event)"
            >
              <v-radio color="secondary" value="self">
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('favorites.selfFavorites') }}</span>
                </template>
              </v-radio>
              <v-radio color="secondary" value="club">
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('favorites.clubFavorites') }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </v-card-text>
      </v-col>
    </v-row>
    <!--Group by-->
    <v-row class="ma-0 justify-center align-center" >
      <v-col cols="12" md="2" class="pa-0">
        <v-card-title class="body-1 font-weight-bold primary--text">{{ $t("favorites.groupBy") }}</v-card-title>
      </v-col>
      <v-col cols="12" md="10" class="d-flex align-center justify-start">
        <v-card-text class="pa-0">
            <v-radio-group background-color="transparent" row hide-details class="ma-0 pa-0"
              :column="$vuetify.breakpoint.smAndDown" :row="!$vuetify.breakpoint.smAndDown"
              v-model="groupBy"
              @change="onGroupByChange($event)"
            >
              <v-radio color="secondary" value="none">
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('favorites.noGrouped') }}</span>
                </template>
              </v-radio>
              <v-radio color="secondary" value="positions">
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('playerDetail.positions') }}</span>
                </template>
              </v-radio>
              <v-radio color="secondary" value="league">
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('table.clientLeagues.league') }}</span>
                </template>
              </v-radio>
              <v-radio color="secondary" value="contractExpiration">
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('favorites.contractExpiration') }}</span>
                </template>
              </v-radio>
              <v-radio color="secondary" value="matchDate">
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('table.playerAllGames.gameDateTooltip') }}</span>
                </template>
              </v-radio>
              <v-radio color="secondary" value="team">
                <template v-slot:label>
                  <span class="body-1 primary--text">{{ $t('table.playerAllGames.team') }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </v-card-text>
      </v-col>
    </v-row>
   </v-card>
    <v-row class="mb-5">
      <v-col :cols="$vuetify.breakpoint.smAndDown ? 6 : 2" class="py-0 d-flex justify-center align-center">
        <div
          class="mr-auto pl-1 primary--text body-2 d-flex flex-column align-center my-1"
        >
          <div class="d-flex">
            <span class="font-weight-bold mr-1">{{totalPlayersSelected}}</span>
            <span>{{$t("favorites.selectedPlayers")}}</span>
          </div>
          <v-tooltip right color="lightSecondary lighten-4" max-width="300" :disabled="totalPlayersSelected > 0 && totalPlayersSelected <= MAXIMUM_SELECTED_PLAYERS">
            <template v-slot:activator="{ on:tooltipOn }">
              <v-btn
                v-on="tooltipOn"
                rounded outlined class="elevation-0 monospace-font px-4" 
                v-bind:class="{'white--text': totalPlayersSelected > 0 && totalPlayersSelected <= MAXIMUM_SELECTED_PLAYERS,
                'primary--text': totalPlayersSelected <= 0 || totalPlayersSelected > MAXIMUM_SELECTED_PLAYERS }"
                :color="getColorCompareButton()"
                @click="onCompareClick()"
                x-small
              >
                <v-icon :color="totalPlayersSelected > 0 && totalPlayersSelected <= MAXIMUM_SELECTED_PLAYERS ? getColorCompareButton() : 'grey'" class="mr-sm-2" small>compare</v-icon>
                <span>{{!$vuetify.breakpoint.smAndDown ? $t("favorites.comparePlayers") : $t("general.compare")}}</span>
              </v-btn>
            </template>
            <span class="black--text body-1" v-if="totalPlayersSelected == 0">{{$t('favorites.selectAtleastOne')}}</span>
            <span class="black--text body-1" v-if="totalPlayersSelected > MAXIMUM_SELECTED_PLAYERS">{{`${$t('favorites.maxSelection')} ${MAXIMUM_SELECTED_PLAYERS} ${$t('general.players')}`}}</span>
          </v-tooltip>
        </div>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.smAndDown ? 6 : 2" class="py-0 d-flex justify-center align-center">
        <div
          class="mr-auto pl-1 primary--text body-2 d-flex flex-column align-center my-1"
        >
          <div class="d-flex">
            <span class="font-weight-bold mr-1">{{totalPlayersSelected}}</span>
            <span>{{$t("favorites.selectedPlayers")}}</span>
          </div>
          <v-tooltip right color="lightSecondary lighten-4" max-width="300" :disabled="totalPlayersSelected > 0">
            <template v-slot:activator="{ on:tooltipOn }">
              <v-btn
                v-on="tooltipOn"
                rounded outlined class="elevation-0 monospace-font px-4" 
                v-bind:class="{'white--text': totalPlayersSelected > 0,'primary--text': totalPlayersSelected <= 0}"
                :color="getColorGenerateXlsxButton()"
                @click="onGenerateXlsxClick()"
                x-small
                :loading="loadingGenerateXlsx"
                :disabled="loadingGenerateXlsx"
              >
                <v-icon :color="totalPlayersSelected > 0 ? getColorGenerateXlsxButton() : 'grey'" class="mr-sm-2" small>description</v-icon>
                <span>{{$t("favorites.generateXlsx")}}</span>
                <template v-slot:loader>
                  <span>{{ $t("favorites.generating") }}</span>
                </template>
              </v-btn>
            </template>
            <span class="black--text body-1">{{$t('favorites.selectAtleastOne')}}</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="mt-0 py-0" v-if="groupBy === 'none' && !$vuetify.breakpoint.smAndDown">
        <v-container
          id="regular-tables"
          fluid
          tag="section"
          class="px-0 py-0"
        >
          <v-data-table
            id="myDataTable"
            :headers="headers"
            :items="playersFiltered"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            class="elevation-1"
            :loading="loading || loadingTable"
            @page-count="pageCount = $event"
            @click:row="onPlayerClick($event)"
            sort-by="pinned" sort-desc
            :key="myDataTableKey"
          >
            <template v-slot:item.selected="{ item }">
              <div v-if="item.playerId" class="d-flex justify-center" @click.exact.stop="">
                <v-checkbox color="secondary" v-model="item.selected" hide-details dense class="ma-0 pa-0"
                  @change="onPlayerSelection($event,item)"></v-checkbox>
              </div>
            </template>
            <template v-slot:item.countryCode="{ item }">
              <div class="d-flex">
                <DriblabCountryFlag :iso="item.countryCode"></DriblabCountryFlag>
                <DriblabCountryFlag className="ml-1" :iso="item.secondCountryCode"></DriblabCountryFlag>
              </div>
            </template>
            <template v-slot:item.name="{ item }">
              <router-link :to="'/player/'+item.playerId" class="nav-link">
                <div class="d-flex flex-column">
                  <span class="body-1" :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'">{{item.name}}</span>
                  <small class="body-2 primary--text subheader-font">{{item.firstName + ' ' + item.secondName}}</small>
                </div>
              </router-link>
            </template>
            <template v-slot:item.teamName="{ item }">
              <router-link :to="'/team/'+item.teamId" class="nav-link d-flex align-center">
                <img :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + item.teamId + '.png'" style="height: 18px; width: 18px;">
                <small class="mx-2 body-2" :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'">{{item.teamName}}</small>
              </router-link>
            </template>
            <template v-slot:item.position="{ item }">
                <v-chip class="monospace-font" style="height: 24px; margin: 1px" :color="getPositionChip(item.fieldPositionId)" text-color="white">{{ getPositionCode(item.fieldPositionId) }}</v-chip>
                <v-chip class="monospace-font" v-if="item.secondFieldPositionId" style="height: 24px; margin: 1px" :color="getPositionChip(item.secondFieldPositionId)" text-color="white">{{ getPositionCode(item.secondFieldPositionId) }}</v-chip>
            </template>
            <template v-slot:item.dallasPositionId="{ item }">
              <v-select
                v-model="item.dallasPositionId"
                :items="dallasPositions"
                item-value="id"
                item-text="name"
                hide-details
                dense
                outlined
                class=""
                @change="onDallasPositionChange(item)"
              >
                <template v-slot:selection="{item}">
                  <v-chip small color="secondary lighten-3" class="body-2 mb-1"
                    v-bind:class="{'white--text':!$vuetify.theme.dark,'primary--text':$vuetify.theme.dark}">
                    <span class="font-weight-bold">{{item.alias}}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{item}">
                  <v-card-text
                    class="pa-0 primary--text font-weight-medium"
                  >{{item.name}}</v-card-text>
                </template>
              </v-select>
            </template>
            <template v-slot:item.age="{ item }">
              <span class="font-weight-bold mr-1">{{item.age}}</span>
              <span v-if="item.dob" >{{item.dob ? `(${item.dob.slice(-2)}')` : ""}}</span>
            </template>
            <template v-slot:item.marketValue="{ item }">
              <div class="d-flex justify-center">
                <span class="">{{currentUserCurrencySymbol}}</span>
                <h4 class="px-2">{{ item.marketValue * 1000 | formatCash(currentUserRate) }}</h4>
                <v-icon v-if="item.marketTrend === 'up'" color="green" small>trending_up</v-icon>
                <v-icon v-if="item.marketTrend === 'same'" color="blue" small>drag_handle</v-icon>
                <v-icon v-if="item.marketTrend === 'down'" color="red" small>trending_down</v-icon>
              </div>
            </template>
            <template v-slot:item.alerts="{ item }">
              <div class="d-flex justify-center">
                <div class="d-flex justify-center" v-for="(alert,index) of item.alerts" :key="index">
                  <v-tooltip top color="lightSecondary lighten-4" max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon small color="error" class="mx-1" v-bind="attrs" v-on="on">{{getAlertIconByType(alert)}}</v-icon>
                    </template>
                    <span class="black--text body-1">{{ getTypeText(alert) }}</span>
                  </v-tooltip>
                </div>
              </div>
            </template>
            <template v-slot:item.delete="{ item }">
              <div v-if="item.playerId" class="pr-1 d-flex justify-center" @click.exact.stop="onRemoveClick(item)">
                <v-icon small>close</v-icon>
              </div>
            </template>
            <!--Actions-->
            <template v-slot:item.actions="{ item }" >
              <!--Pin-->
              <v-btn icon x-small @click.stop="onPinClick(item)"
                v-if="item.followedByUserId === currentUser.id"
              ><v-icon small :color="item.pinned ? 'secondary' : 'grey lighten-1 z-10'">beenhere</v-icon>
              </v-btn>
              <!--Remove from favs-->
              <v-btn v-if="item.followedByUserId === currentUser.id" elevation="0" icon x-small class="ms-1" color="grey lighten-1"
                @click.stop="onRemoveFavClick(item)">
                <v-icon small>delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <div v-if="pageCount > 1" class="text-center pt-2">
            <v-pagination class="monospace-font" color="secondary" circle v-model="page" :length="pageCount"></v-pagination>
          </div>
        </v-container>
      </v-col>
      <v-col cols="12" class="mt-0 py-0" v-if="groupBy !== 'none' && !showDallasPositionsPanel">
        <v-expansion-panels multiple hover focusable>
          <v-expansion-panel
            v-for="group in groups" v-bind:key="group.title"
          >
            <v-expansion-panel-header>
              <div class="d-flex align-center" v-bind:class="{'justify-space-between': groupBy === 'league'}" >
               <img v-if="groupBy === 'league'" :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/' + group.items[0].leagueId + '.png'" contain
               height="64" @error="onImageLoadFailure($event)">
               <v-badge
                  :color="$vuetify.theme.dark ? 'secondary' : 'primary lighten-1'"
                  :content="group.items.length"
                  inline
                >
                  <span class="mr-2">{{group.title}}</span>
                </v-badge>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="6" md="4" xl="3" class="d-flex px-0 px-sm-3 pb-1" v-for="player in group.items"  v-bind:key="player.playerId">
                  <PlayerFavoriteCard :player="player" :removable="mode === 'collection'" @removeClicked="onRemoveClick(player)"
                  @selectionChange="onPlayerSelection($event,player)"
                  :MAXIMUM_SELECTED_PLAYERS="MAXIMUM_SELECTED_PLAYERS"></PlayerFavoriteCard>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <!-- Panel just for client = Dallas(10400) and group by 'positions' -->
      <v-col cols="12" class="mt-0 py-0" v-if="showDallasPositionsPanel">
        <!--<span>Panel para Dallas</span>-->
        <v-expansion-panels multiple hover focusable>
          <v-expansion-panel
            v-for="group in groups" v-bind:key="group.title"
          >
            <v-expansion-panel-header>
              <div class="d-flex align-center">
               <v-badge
                  :color="$vuetify.theme.dark ? 'secondary' : 'primary lighten-1'"
                  :content="group.items.length"
                  inline
                >
                  <span class="mr-2">{{group.title}}</span>
                </v-badge>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content id="myExpansionPanel">
              <v-row>
                <v-col cols="12" class="mt-0 py-0">
                  <v-container
                    id="regular-tables"
                    fluid
                    tag="section"
                    class="px-0 py-0"
                  >
                    <v-data-table
                      id="myDataTable"
                      :headers="headers"
                      :items="group.items"
                      :page.sync="page"
                      :items-per-page="itemsPerPage"
                      hide-default-footer
                      class="elevation-1 px-0"
                      :loading="loading || loadingTable"
                      @page-count="pageCount = $event"
                      @click:row="onPlayerClick($event)"
                    >
                      <template v-slot:item.selected="{ item }">
                        <div v-if="item.playerId" class="pl-3 d-flex justify-center" @click.exact.stop="">
                          <v-checkbox color="secondary" v-model="item.selected" hide-details dense class="ma-0 pa-0"
                            @change="onPlayerSelection($event,item)"></v-checkbox>
                        </div>
                      </template>
                      <template v-slot:item.countryCode="{ item }">
                        <div class="d-flex">
                          <DriblabCountryFlag :iso="item.countryCode"></DriblabCountryFlag>
                          <DriblabCountryFlag className="ml-1" :iso="item.secondCountryCode"></DriblabCountryFlag>
                        </div>
                      </template>
                      <template v-slot:item.name="{ item }">
                        <router-link :to="'/player/'+item.playerId" class="nav-link">
                          <div class="d-flex flex-column">
                            <span>{{item.name}}</span>
                            <small class="font-weight-light primary--text" :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'">{{item.firstName + ' ' + item.secondName}}</small>
                          </div>
                        </router-link>
                      </template>
                      <template v-slot:item.teamName="{ item }">
                        <router-link :to="'/team/'+item.teamId" class="nav-link d-flex align-center">
                          <img :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + item.teamId + '.png'" style="height: 18px; width: 18px;">
                          <small class="mx-2 body-2" :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'">{{item.teamName}}</small>
                        </router-link>
                      </template>
                      <template v-slot:item.position="{ item }">
                          <v-chip class="monospace-font" style="height: 24px; margin: 1px" :color="getPositionChip(item.fieldPositionId)" text-color="white">{{ getPositionCode(item.fieldPositionId) }}</v-chip>
                          <v-chip class="monospace-font" v-if="item.secondFieldPositionId" style="height: 24px; margin: 1px" :color="getPositionChip(item.secondFieldPositionId)" text-color="white">{{ getPositionCode(item.secondFieldPositionId) }}</v-chip>
                      </template>
                      <template v-slot:item.dallasPositionId="{ item }">
                        <v-select
                          v-model="item.dallasPositionId"
                          :items="dallasPositions"
                          item-value="id"
                          item-text="name"
                          hide-details
                          dense
                          outlined
                          class=""
                          @change="onDallasPositionChange(item)"
                        >
                          <template v-slot:selection="{item}">
                            <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 black--text">
                              <span class="font-weight-bold">{{item.alias}}</span>
                            </v-chip>
                          </template>
                          <template v-slot:item="{item}">
                            <v-card-text
                              class="pa-0 primary--text font-weight-medium"
                            >{{item.name}}</v-card-text>
                          </template>
                        </v-select>
                      </template>
                      <template v-slot:item.age="{ item }">
                        <span class="font-weight-bold mr-1">{{item.age}}</span>
                        <span v-if="item.dob" >{{item.dob ? `(${item.dob.slice(-2)}')` : ""}}</span>
                      </template>
                      <template v-slot:item.marketValue="{ item }">
                        <div class="d-flex justify-center">
                          <span class="">{{currentUserCurrencySymbol}}</span>
                          <h4 class="px-2">{{ item.marketValue * 1000 | formatCash(currentUserRate) }}</h4>
                          <v-icon v-if="item.marketTrend === 'up'" color="green" small>trending_up</v-icon>
                          <v-icon v-if="item.marketTrend === 'same'" color="blue" small>drag_handle</v-icon>
                          <v-icon v-if="item.marketTrend === 'down'" color="red" small>trending_down</v-icon>
                        </div>
                      </template>

                      <template v-slot:item.alerts="{ item }">
                        <div class="d-flex justify-center">
                          <div class="d-flex justify-center" v-for="(alert,index) of item.alerts" :key="index">
                            <v-tooltip top color="lightSecondary lighten-4" max-width="300">
                              <template v-slot:activator="{ on, attrs }">
                                  <v-icon small color="error" class="mx-1" v-bind="attrs" v-on="on">{{getAlertIconByType(alert)}}</v-icon>
                              </template>
                              <span class="black--text body-1">{{ getTypeText(alert) }}</span>
                            </v-tooltip>
                          </div>
                        </div>
                      </template>

                      <template v-slot:item.delete="{ item }">
                        <div v-if="item.playerId" class="pr-1 d-flex justify-center" @click.exact.stop="onRemoveClick(item)">
                          <v-icon small>close</v-icon>
                        </div>
                      </template>

                    </v-data-table>
                    <div v-if="pageCount > 1" class="text-center pt-2">
                      <v-pagination v-model="page" :length="pageCount" class="monospace-font" color="secondary" circle></v-pagination>
                    </div>
                  </v-container>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row v-if="groupBy === 'none' && $vuetify.breakpoint.smAndDown" class="card">
      <v-card class="mx-3 pb-2" elevation="0" outlined>
      <v-col cols="12" class="d-flex pb-1" v-for="player in playersFiltered"
         v-bind:key="player.playerId">
        <PlayerFavoriteCard :player="player" :removable="mode === 'collection'" @removeClicked="onRemoveClick(player)"
          @selectionChange="onPlayerSelection($event,player)"
          :showPinnedBtn="true" @pinClicked="onPinClick($event)"
          :showRemoveFavBtn="true" @removeFavClicked="onRemoveFavClick($event)"
          :MAXIMUM_SELECTED_PLAYERS="MAXIMUM_SELECTED_PLAYERS"></PlayerFavoriteCard>
      </v-col>
      </v-card>
    </v-row>

    <!--Delete analysis confirmation-->
    <ConfirmationModal
      @confirmation="onRemoveFavConfirmation($event)"
      ref="confirmationRemoveModal"
      message="playerDetail.removeFavorite"
      title="general.confirmationTitle"
    ></ConfirmationModal>
  </v-container>
</template>

<script>

import PlayerService from '../services/player/player.service';
import UserService from "../services/user.service";
import ReportGeneratorService from '../services/reportGenerator.service';
import PlayerFavoriteCard from './player/PlayerFavoriteCard';
import DriblabCountryFlag from './base/DriblabCountryFlag';
import * as _ from 'lodash';
import * as moment from 'moment';
import {formatCash, getChipColorByPosition, getCurrencies, getPositionCode, getAlertIcon, getAlertTypeText} from '../utils/functions';
import ConfirmationModal from './base/ConfirmationModal.vue';

export default {
  name: 'Favorites',
  components: {
    PlayerFavoriteCard,
    DriblabCountryFlag,
    ConfirmationModal
  },
  filters: {
    formatCash(n,rate) {
      return formatCash(n * rate)
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    totalPlayersSelected(){
      return _.size(this.selectedPlayers);
    },
    currentUserCurrency(){
      return this.$store.getters["auth/currency"];
    },
    currentUserRate(){
      let rate = this.currentUserCurrency === "EUR" ? 1 : this.$store.getters["exchange/rates"][this.$store.getters["auth/currency"]];
      return rate ? rate : 1;
    },
    currencies(){
      return getCurrencies();
    },
    currentUserCurrencySymbol(){
      let currentCurrencyObj = _.find(this.currencies,(c) => c.code === this.currentUserCurrency)
      return currentCurrencyObj.symbol;
    },
    isDallas(){
      return this.currentUser.clientId === 10400;
    },
    //Return true if client is Dallas (10400) and 'positions' group by is selected
    showDallasPositionsPanel(){
      return this.groupBy === "positions" && this.isDallas;
    },
    alertTitle() {
      const alertType = this.$route.query.type;
      switch (Number(alertType)) {
        case 1:
          return this.$t("inbox.new_game_alert")
        case 2:
          return this.$t("inbox.new_team_alert")
        case 3:
          return this.$t("inbox.new_marketValue_alert")
        case 4:
          return this.$t("inbox.new_injury_alert")
        case 5:
          return this.$t("inbox.new_contract_alert")
        default: return "Alert"

      }
    }
  },
  title () {
    return this.$t("general.favorites");
  },
  data() {
    return {
      overrideWindowTitle: true,
      groups: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: "", align: 'center', value: 'selected' },
        { text: '', width: "5%", align: 'center', value: 'countryCode' },
        { text: this.$t("playerDetail.name"), align: 'start', value: 'name' },
        { text: this.$t("table.history.team"), align: 'start', value: 'teamName' },
        { text: this.$t("playerDetail.positions"), align: 'center', value: 'position' },
        { text: this.$t("playerDetail.age"), align: 'center', value: 'age' },
        { text: this.$t("playerDetail.height"), align: 'center', value: 'height' },
        { text: this.$t("table.transfers.marketValue"), align: 'center', value: 'marketValue' },
        { text: this.$t("inbox.alerts"), width:"10%", align: 'center', value: 'alerts'},
        { text: "", align: "center", value: "actions", sortable: false, width: 80 },
      ],
      dallasPositions: [
        {id: 1, name: "#1 " + this.$t("dPos.1.name"), alias: "#1 " + this.$t("dPos.1.alias")},
        {id: 2, name: "#2 " + this.$t("dPos.2.name"), alias: "#2 " + this.$t("dPos.2.alias")},
        {id: 3, name: "#3 " + this.$t("dPos.3.name"), alias: "#3 " + this.$t("dPos.3.alias")},
        {id: 4, name: "#4 " + this.$t("dPos.4.name"), alias: "#4 " + this.$t("dPos.4.alias")},
        {id: 5, name: "#5 " + this.$t("dPos.5.name"), alias: "#5 " + this.$t("dPos.5.alias")},
        {id: 6, name: "#6 " + this.$t("dPos.6.name"), alias: "#6 " + this.$t("dPos.6.alias")},
        {id: 7, name: "#7 " + this.$t("dPos.7.name"), alias: "#7 " + this.$t("dPos.7.alias")},
        {id: 8, name: "#8 " + this.$t("dPos.8.name"), alias: "#8 " + this.$t("dPos.8.alias")},
        {id: 9, name: "#9 " + this.$t("dPos.9.name"), alias: "#9 " + this.$t("dPos.9.alias")},
        {id: 10, name: "#10 " + this.$t("dPos.10.name"), alias: "#10 " + this.$t("dPos.10.alias")},
        {id: 11, name: "#11 " + this.$t("dPos.11.name"), alias: "#11 " + this.$t("dPos.11.alias")}
      ],
      showOnly: "self",
      groupBy: "none",
      selectedPlayers: [],
      MAXIMUM_SELECTED_PLAYERS: this.$vuetify.breakpoint.smAndDown ? 2 : 5,
      loading: false,
      loadingGenerateXlsx: false,
      playersFiltered: [],
      myDataTableKey: 0,
      favToDelete: null
    };
  },
  props:{
    mode:{
      type: String,
      default: 'favorite',
    },
    players:{
      type: Array,
      default: () => [],
      required: false
    },
    alerts:{
      type:Array,
      default: () => []
    },
    collectionName: {
      type: String,
      required: false
    },
    collectionId: {
      type: Number,
      required: false
    },
    loadingTable: {
      type: Boolean,
      required: false
    }
  },
  mounted() {
    if(this.mode === 'collection'){
      this.playersFiltered = this.players;
      //For dallas, add Dallas Position column on table
      if(this.isDallas){
        this.headers.splice(5, 0, { text: "Dallas Position", width:"10%", align: 'center', value: 'dallasPositionId' });
      }
      this.headers.push({ text: "", align: 'center', value: 'delete' }) // Posibility to remove player from collection
    } else if (this.mode === 'favorite') {
      //For dallas, add Dallas Position column on table
      this.loadFavorites();
    } else {
      this.loadFavsAndCollectionPlayers();
    }
  },
  watch:{
    players: function(newValue,oldValue){
      this.prepareGroups();
    },
    alerts: function(newValue,oldValue){
      if(this.mode === 'favorite'){
        this.loadFavorites();
      } else if (this.mode === 'alert') {
        this.loadFavsAndCollectionPlayers();
      }
    },
    '$route.query.type': function(newValue,oldValue){
        this.loadFavsAndCollectionPlayers();
    }
  },
  methods: {

    loadFavorites: async function() {
      this.loading = true;
      let onlySelf = this.showOnly === 'self';
      let favoritesResponse =  await PlayerService.getFollowedPlayers(this.$store.state.auth.user.id,onlySelf);


      this.playersFiltered = _.chain(favoritesResponse.data).map((d) => {
        d.alerts = _.filter(this.alerts,(a) => a.playerId === d.playerId);
        return d;
      }).orderBy(['pinned', 'alerts'],['desc', 'desc']).value();
      this.prepareGroups();
      this.loading = false;
    },
    loadFavsAndCollectionPlayers: function() {
      const playersWithAlerts = _.chain(this.players).map((d) => { d.alerts = _.filter(this.alerts,(a) => a.playerId === d.playerId); return d; }).orderBy("alerts","desc").value();
      const alertType = this.$route.query.type;
      if (Number(alertType) === 1) { //Game
        const playerIds = playersWithAlerts.map(p => p.alerts).flat().filter(a => a.alertTypeId === 11).map(p => p.playerId); 
        this.playersFiltered = playersWithAlerts.filter(p => playerIds.includes(p.playerId));
      } else if (Number(alertType) === 2) { //Team
        const playerIds = playersWithAlerts.map(p => p.alerts).flat().filter(a => a.alertTypeId === 9).map(p => p.playerId); 
        this.playersFiltered = playersWithAlerts.filter(p => playerIds.includes(p.playerId));
      } else if (Number(alertType) === 3) { //Market value
        const playerIds = playersWithAlerts.map(p => p.alerts).flat().filter(a => a.alertTypeId === 8).map(p => p.playerId); 
        this.playersFiltered = playersWithAlerts.filter(p => playerIds.includes(p.playerId));
      } else if (Number(alertType) === 4) { //Injury
        const playerIds = playersWithAlerts.map(p => p.alerts).flat().filter(a => a.alertTypeId === 10).map(p => p.playerId); 
        this.playersFiltered = playersWithAlerts.filter(p => playerIds.includes(p.playerId));
      } else if (Number(alertType) === 5) { //Contract
        const playerIds = playersWithAlerts.map(p => p.alerts).flat().filter(a => a.alertTypeId === 12).map(p => p.playerId); 
        this.playersFiltered = playersWithAlerts.filter(p => playerIds.includes(p.playerId));
      };
    },
    getExpirationGroup(date) {
      let dateAsMoment = moment(date,'DD/MM/YYYY');
      let month = dateAsMoment.month() +1;
      let year = dateAsMoment.year()
      if(month >=1 && month <=6) return {period:`${year}a`,text:year  + ' ' + this.$t("expiration.summer")};
      if(month >=7 && month <=12) return {period:`${year}b`,text:year  + ' ' + this.$t("expiration.winter")};
    },
    getPositionChip(position) {
      return getChipColorByPosition(position);
    },
    onPlayerClick(event){
      if(!this.isDallas){
        event.selected = !event.selected;
        this.onPlayerSelection(event.selected,event);
      }
    },
    onShowOnlyChange(event){
      this.loadFavorites()
    },
    onGroupByChange(event){
      if(event !== 'none'){
        this.prepareGroups()
      }
    },
    prepareGroups(){
      let groups;
      switch(this.groupBy){
        case 'positions':
          groups = _.chain(this.playersFiltered).forEach(p => {
            //Add dallasPositionId key to all the players
            if (!p.dallasPositionId) this.addDallasPosition(p);

            p.positionGroup = (Number.isInteger(p.dallasPositionId))
            ? this.$t("dPos." + p.dallasPositionId + ".name")
            : `${p.fieldPositionId} - ${this.getPositionCode(p.fieldPositionId)}`;
            }).sortBy(function(data) { return data.dallasPositionId }) //Sort collection by dallasPositionId
            .groupBy('positionGroup').value();
          break;
        case 'league':
          groups = _.chain(this.playersFiltered).groupBy('leagueName').value();
          break;
        case 'contractExpiration':
          let winterThreshold = moment().set('month',9).set('date',5)
          let summerThreshold = moment().set('month',1).set('date',5)
          let isWinter = moment().isSameOrAfter(winterThreshold)
          groups = _.chain(this.playersFiltered).filter(p => {
            return ((isWinter && moment(p.contractExpirationDate,'DD/MM/YYYY').isSameOrAfter(winterThreshold))
            || (!isWinter && moment(p.contractExpirationDate,'DD/MM/YYYY').isSameOrAfter(summerThreshold)));
          }).forEach(p => {
            let expirationGroup = this.getExpirationGroup(p.contractExpirationDate)
            p.expirationGroup = expirationGroup.text;
            p.expirationPeriod = expirationGroup.period;
          }).orderBy(['expirationPeriod'],[,'asc']).groupBy('expirationGroup').value();
          break;
        case 'matchDate':
          groups = _.chain(this.playersFiltered).map(p => { p.matchTime = moment(p.matchDate,"DD/MM/YYYY").unix(); return p;})
          .orderBy("matchTime","asc").groupBy('matchDate').value();
          break;
        case 'team':
          groups = _.chain(this.playersFiltered).groupBy('teamName').value();
          break;
      }
      this.groups = _.map(groups,(val,key) => {
        return {
          title: key != 'null' ? key : "TBA",
          items: val
        }
      })
    },
    onImageLoadFailure(event){
      event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png";
    },
    onRemoveClick(item){
      this.$emit("removeClicked",item);
    },
    onPlayerSelection(selected,player){
      if(selected){
        this.selectedPlayers.push(player);
      }else{
        this.selectedPlayers = _.filter(this.selectedPlayers,(p) => p.playerId !== player.playerId)
      }
      this.myDataTableKey++;
    },
    onCompareClick(){
      if(this.totalPlayersSelected > 0 && this.totalPlayersSelected <= this.MAXIMUM_SELECTED_PLAYERS){
        this.$router.push({path: `/player-comparison/${_.map(this.selectedPlayers,(p) => p.playerId)}`})
      }
    },
    async onGenerateXlsxClick(){
      if(this.totalPlayersSelected > 0){
        this.loadingGenerateXlsx = true;
        let playersSelectedIds = this.selectedPlayers.map(p => p.playerId);

        //Generate xlsx
        let response =  await ReportGeneratorService.generatePlayersCollectionsXlsx(playersSelectedIds, this.collectionId);

        var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});

        saveAs(blob, this.collectionName + ".xlsx");
        this.loadingGenerateXlsx = false;

        //Save on User Search
        this.postSearch({type: "xlsx"});

      }
    },
    async postSearch(metaData){
      const authorized = true;
      const category ='collections';
      let urlId = this.collectionId;
      const tool = 'collections';
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;
      const metaInfo = JSON.stringify(metaData);
      let searchResponse = await UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser, metaInfo);
      UserService.putLastSearchRendered({category,tool,id:searchResponse.data})
    },
    getColorCompareButton(){
      let baseColorsTheme = this.$vuetify.theme.dark ? ['grey darken-2', 'primary'] : ['grey lighten-2', 'primary']
      return this.totalPlayersSelected <= 0 || this.totalPlayersSelected > this.MAXIMUM_SELECTED_PLAYERS ? baseColorsTheme[0] : baseColorsTheme[1];
    },
    getColorGenerateXlsxButton(){
      let baseColorsTheme = this.$vuetify.theme.dark ? ['grey darken-2', 'green'] : ['grey lighten-2', 'green']
      return this.totalPlayersSelected <= 0 ? baseColorsTheme[0] : baseColorsTheme[1];
    },
    getAlertIconByType(alert){
      return getAlertIcon(alert);
    },
    getTypeText(alert) {
      return getAlertTypeText(alert, this.currentUserLanguage);
    },
    onDallasPositionChange(player){
      PlayerService.updateDallasPositionId(player.playerId, player.dallasPositionId);
    },
    addDallasPosition(player) {
      switch(player.fieldPositionId){
        case 1: //GK
          player.dallasPositionId = 1.1;
          break;
        case 3: //DR
          player.dallasPositionId = 2.1;
          break;
        case 2: //DC
          player.dallasPositionId = 3.1;
          break;
        case 4: //DL
          player.dallasPositionId = 5.1;
          break;
        case 15: //DMR
          player.dallasPositionId = 6.1;
          break;
        case 5: //DMC
          player.dallasPositionId = 6.2;
          break;
        case 16: //DML
          player.dallasPositionId = 6.3;
          break;
        case 7: //MR
          player.dallasPositionId = 7.1;
          break;
        case 6: //MC
          player.dallasPositionId = 8.1;
          break;
        case 8: //ML
          player.dallasPositionId = 11.1;
          break;
        case 10: //AMR
          player.dallasPositionId = 7.2;
          break;
        case 9: //AMC
          player.dallasPositionId = 10.2;
          break;
        case 11: //AML
          player.dallasPositionId = 11.2;
          break;
        case 12: //FWR
          player.dallasPositionId = 7.3;
          break;
        case 14: //FW
          player.dallasPositionId = 9.1;
          break;
        case 13: //FWL
          player.dallasPositionId = 11.3;
          break;
        default:
          break;
      }
    },
    getPositionCode(position) {
      return getPositionCode(this.currentUser.fieldPositionCodeId, position);
    },
    async onPinClick(item) {
      item.pinned = !item.pinned;
      await PlayerService.switchPinnedPlayerFav(item.playerId, item.pinned);
      this.playersFiltered = _.orderBy(this.playersFiltered, ['pinned', 'alerts'], ['desc', 'desc']);
      this.myDataTableKey++;
    },
    onRemoveFavClick(item) {
      this.favToDelete = item;
      this.$refs.confirmationRemoveModal.open();
    },
    async onRemoveFavConfirmation(confirmation) {
      if (confirmation) {
        this.loading = true;
        await PlayerService.postPlayerFollow(this.currentUser.id, this.favToDelete.playerId);
        await this.loadFavorites();
        this.loading = false;
      };
      this.favToDelete = null;
      this.$refs.confirmationRemoveModal.close();
    }
  }
};
</script>
<style lang="scss">
  #myExpansionPanel{
    .v-expansion-panel-content__wrap{
      padding: 0px;
    }
  }
  #myDataTable{
    th {
      padding: 0px;
    }
  }
  #myDataTable{
    td {
      padding: 0 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Favorites.vue